import { Box, Button, Text, BoxProps, Link, VStack, AspectRatio } from "@chakra-ui/react";
import { FC, useEffect } from "react";
import { DEFAULT_ASPECT_RATIO } from "../constants";
import { useInView } from "react-intersection-observer";

const Item: FC<NonNullable<Gatsby.PageBlockAnimationFragment["items"]>[number] & {
  selected: boolean,
  desktopInView: boolean,
  forceMP4: boolean,
  progressBarFillingIn: string,
  progressBarFillingOut: string,
  duration: number,
  progressBarRemainingWidthProps: {
    width?: string
  },
  onClick?: () => void,
  containerProps?: BoxProps
}> = ({
  label,
  link,
  title,
  description,
  mobile_video_mp4,
  mobile_video_webm,
  selected,
  desktopInView,
  progressBarRemainingWidthProps,
  progressBarFillingIn,
  progressBarFillingOut,
  duration,
  onClick,
  containerProps
}) => {
    const mobileVideoMP4 = mobile_video_mp4?.url;
    const mobileVideoWebM = mobile_video_webm?.url;


    useEffect(() => {
      if (typeof window !== "undefined") {
        const videoElement = document.getElementById('mobile-video') as HTMLVideoElement;
        const videoMP4Element = document.getElementById("mobile-video-mp4");
        const videoWebMElement = document.getElementById("mobile-video-webm");
        if (videoElement) {
          videoElement.pause();

          if (videoMP4Element && mobileVideoMP4) {
            videoMP4Element.setAttribute("src", mobileVideoMP4);
          }

          if (videoWebMElement && mobileVideoWebM) {
            videoWebMElement.setAttribute("src", mobileVideoWebM);
          }

          videoElement.load();
        }
      }
    }, [mobileVideoMP4, mobileVideoWebM]);

    return (
      <VStack
        alignItems="stretch"
        justifyContent="flex-start"
        width="full"
        spacing="0"
      >
        <Box
          mb="0px !important"
          px={{ base: "space-24", md: "0" }}
          fontFamily="body"
          fontWeight="normal"
          color={selected ? "text-primary" : "monochrome-400"}
          {...containerProps}
        >
          <Button
            w="full"
            display="inline-flex"
            fontSize="font-18"
            lineHeight="base"
            letterSpacing="semitight"
            fontWeight="normal"
            justifyContent="left"
            variant="ghost"
            paddingX="0"
            paddingTop={{ base: "0 !important", md: "8px !important" }}
            paddingBottom={selected ? "space-16" : "0 !important"}
            backgroundColor="white"
            _active={{
              color: "text-primary"
            }}
            _hover={{
              backgroundColor: "white",
            }}
            onClick={() => onClick?.()}
          >
            {title}
          </Button>

          {selected ? (
            <Box
              marginBottom={{ base: "space-16", md: "space-8" }}
              textAlign="left"
            >
              <Text
                variant="body-md-reg"
                textAlign="left"
                maxWidth={{ base: "full", md: "70%" }}
              >
                {description}
              </Text>

              {link ? (
                <Button
                  as="a"
                  display="inline-block"
                  href={link.url}
                  target={link.target}
                  marginTop="space-16"
                  variant="secondary"
                  size="sm"
                >
                  {label}
                </Button>
              ) : null}
            </Box>
          ) : null}

          {selected ? (
            <Box
              display="inline-block"
              animation={desktopInView ? `${progressBarFillingIn} ${duration}ms linear infinite` : undefined}
              borderTop="1px solid"
              borderColor={"primary-green"}
            />
          ) : null}

          <Box
            animation={selected && desktopInView ? `${progressBarFillingOut} ${duration}ms linear infinite` : undefined}
            {...progressBarRemainingWidthProps}
            borderTop="1px solid"
            display="inline-block"
            borderColor="border-primary"
          />
        </Box>
      </VStack>
    )
  };

export default Item;
